module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-07.507dcc10.jpg";